import { Automation, Step } from 'pages/AutomationEngine/types';
import TriggerCard from '__pages/AutomationEngine/Engine/Steps/TriggerCard';
import { CardProps } from '../../types';
import {
  NewEntityCreatedValues,
  TriggerAction,
} from 'pages/AutomationEngine/dialogs/GoalAndTriggerWizard/subsections/NewEntityCreated/common';
import { TFunction } from 'react-i18next';

const actionLookup = (action: TriggerAction, t: TFunction) => {
  const actionDictionary: Record<TriggerAction, string> = {
    create_only: t('Created'),
    create_and_unarchive: t('Created or Unarchived'),
    unarchive_only: t('Unarchived'),
  };

  return actionDictionary[action] || actionDictionary['create_only'];
};

export const content = (step: CardProps['step']) => step.description;

export const getDescription = ({
  automation,
  step,
  t,
}: {
  automation: Automation;
  step: Step & { details: NewEntityCreatedValues };
  t: TFunction;
}) => {
  const { details } = step;

  // always fall back to create if action is not set for backwards compatibility
  const value = details?.action || 'create_only';

  const prefix = value === 'unarchive_only' ? '' : t('New ');

  const { entityName } = automation.customObject;

  const action = actionLookup(value, t);

  return `${prefix}${entityName} ${action}`;
};

export default function Card({ step, ...others }: CardProps) {
  return <TriggerCard {...others}>{content(step)}</TriggerCard>;
}
